// General
import "./orientation-mounted.scss";
import { useEffect } from "react";
// Static Data
import utilityConst from "../../../../const/utilityConst";
// Redux
import { useSelector, useDispatch } from "react-redux";
import { updateScreenOrientation } from "../../../../redux/store/appStore";
import { updatePreventLandscapeDialog } from "../../../../redux/store/dialogStore";
// react-device-detect
import {
  isAndroid,
  isIOS,
  isIPad13,
  isMobile,
  deviceDetect,
  isTablet,
} from "react-device-detect";

const OrientationMounted = () => {
  // Redux variables
  const screenOrientation = useSelector((state) => state.app.screenOrientation);
  const dispatch = useDispatch();

  // Lifecycle | Mounted
  useEffect(() => {
    let resetScrollTimeout;

    // iOS PWA (26+) can leave the window scrolled after rotating, which visually looks fine
    // but shifts the layout/hit-test position of fixed elements (e.g. bottom navbar) upwards
    const resetViewportScroll = () => {
      // Keyboard opening also fires resize and iOS scrolls the window to keep the input visible,
      // resetting here would push the UI back down behind the keyboard
      if (document.activeElement?.matches("input, textarea, [contenteditable='true']")) {
        return;
      }

      if (window.scrollX !== 0 || window.scrollY !== 0) {
        window.scrollTo(0, 0);
      }
    };

    const handleOrientationChange = () => {
      dispatch(
        updateScreenOrientation(
          window?.screen?.orientation?.type?.includes("landscape")
            ? utilityConst.screenOrientation.landscape
            : utilityConst.screenOrientation.portrait
        )
      );

      // orientationchange fires before iOS finishes resizing the viewport
      clearTimeout(resetScrollTimeout);
      resetScrollTimeout = setTimeout(resetViewportScroll, 300);
    };

    const handleResize = () => {
      requestAnimationFrame(resetViewportScroll);
    };

    window.addEventListener("orientationchange", handleOrientationChange);
    window.addEventListener("resize", handleResize);
    window.visualViewport?.addEventListener("resize", handleResize);

    return () => {
      clearTimeout(resetScrollTimeout);
      window.removeEventListener("orientationchange", handleOrientationChange);
      window.removeEventListener("resize", handleResize);
      window.visualViewport?.removeEventListener("resize", handleResize);
    };
  }, []);

  // Lifecycle | Check for update | orientation
  useEffect(() => {
    if (isMobile && !isTablet) {
      if (
        screenOrientation === utilityConst.screenOrientation.landscape &&
        process.env["REACT_APP_ENVIRONMENT"] !== "development"
      ) {
        dispatch(updatePreventLandscapeDialog(true));
      } else {
        dispatch(updatePreventLandscapeDialog(false));
      }
    }
  }, [screenOrientation]);

  return <div id="orientation-mounted"></div>;
};

export default OrientationMounted;
